addEventListener("DOMContentLoaded", (event) => {

    let swipers           = document.querySelectorAll('.landing__products--swiper');

    if ( swipers ) {
      [].forEach.call(swipers, (swiperInstance) => {
        const swiper = new Swiper(swiperInstance, {
          slidesPerView: 2,
          spaceBetween: 20,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
        });
      })
    }

});

